import React, { useEffect, useState } from 'react';
import { Col, Row, Spin } from 'antd';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const CollectionsDays = (props) => {
  const { collectionsList, collectionLoading } = props;
  const [collectionListData, setCollectionListData] = useState([]);
  const { t } = useTranslation();
  useEffect(() => {
    if (collectionsList?.collectionDay?.length > 0) {
      let binsCopy = [...collectionsList.collectionDay];
      const getSortableString = (dateStr) => {
        let parts = dateStr.split('-');
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      };
      binsCopy.sort((a, b) => {
        let dateA = new Date(getSortableString(a.collectionDay));
        let dateB = new Date(getSortableString(b.collectionDay));
        return dateA - dateB;
      });

      setCollectionListData(binsCopy);
    } else {
      setCollectionListData([]);
    }
  }, [collectionsList]);

  const isSmallScreen = window.matchMedia('(max-width: 768px)').matches;

  return (
    <div className="">
      {collectionLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '20vh' }}>
          <Spin />
        </div>
      ) : (
        <div>
          {collectionListData?.length > 0 ? (
            <>
              <h2 className="mt-4 govuk-heading-s"> {t('yourNextCollection')}</h2>
              <Row gutter={[16, 16]} className="d-flex justify-content-between mb-4 mt-2">
                {collectionListData.map((d, index) => {
                  const date = moment(d.collectionDay, 'DD-MM-YYYY');
                  const followingDate = moment(d.followingDay, 'DD-MM-YYYY');
                  const dayName = date.format('dddd');
                  const monthName = date.format('MMMM');
                  const day = date.date();
                  const followingDayName = followingDate.format('dddd');
                  const followingMonthName = followingDate.format('MMMM');
                  const followingDay = followingDate.date();
                  return (
                    <Col className="" key={index} xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div
                        className="p-2 d-flex flex-column justify-content-between"
                        style={{ backgroundColor: d.binColor, height: isSmallScreen ? '230px' : '250px', width: '100%' }}
                      >
                        <div>
                          <h3 className="text-white" style={{ fontSize: '16px' }}>
                            {d.binType}
                          </h3>
                          <div className="text-white  fw-bold" style={{ fontSize: '24px' }}>
                            {`${t(`${dayName.toLowerCase()}`)} ${day} ${t(`${monthName.toLowerCase()}`)}`}
                          </div>
                        </div>
                        <div className="text-white" style={{ fontSize: '16px' }}>
                          {d.followingDay ? `${t('followedBy')} ${`${t(`${followingDayName.toLowerCase()}`)} ${followingDay} ${t(`${followingMonthName.toLowerCase()}`)}`}` : ''}
                        </div>
                        <div className="text-white" style={{ fontSize: '16px', height: 'auto' }}>
                          {d.description}
                        </div>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </>
          ) : collectionsList?.collectionDay === null ? (
            <div className="govuk-warning-text mt-5">
              <span className="govuk-warning-text__icon" aria-hidden="true">
                !
              </span>
              <strong className="govuk-warning-text__text">
                <span className="govuk-visually-hidden">{t('warning')}</span>
                {t('noCollectionWarning')}
              </strong>
            </div>
          ) : (
            ''
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ collectionData }) => {
  const { collectionsList, collectionLoading } = collectionData;
  return { collectionsList, collectionLoading };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionsDays);
